// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "finance.islamicoin",
    name: "ISLAMIwallet",
    homepage: "https://islamicoin.finance/islamiwallet",
    image_id: "8d723c78-28ad-4610-901f-ea391d7e8d00",
    app: {
        browser: "https://islamiwallet.com",
        ios: "https://apps.apple.com/lb/app/islamiwallet/id1631212925",
        android: "https://play.google.com/store/apps/details?id=com.islami.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "islamiwallet://islami.com/path/",
        universal: "https://islamicoin.finance/.well-known/assetlinks.json",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map